<template>
  <b-container
    class="main-container collapse navbar-collapse"
    lg="pl-5"
    md="p-0"
    sm="p-0"
  >
    <ul class="navbar-nav">
      <li
        v-for="(nav, i) in navbarOptions"
        :key="i"
        :class="{'nav-item dropdown' : nav.children }"
      >
        <router-link
          v-if="!nav.children"
          class="nav-link font-weight-bold f-s-14 l-h-17 main-grey pl-0 pr-4"
          :to="{name: nav.routeName}"
        >
          <span class="blue-hover">{{ nav.label }}</span>
        </router-link>
        <div v-else>
          <span
            class="nav-link dropdown-toggle
            font-weight-bold f-s-14 l-h-17 main-grey pl-0 pr-4 blue-hover"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <router-link
              class="font-weight-bold f-s-14 l-h-17 main-grey blue-hover"
              :to="{name: nav.routeName }"
            >
              {{ nav.label }}
            </router-link>
          </span>
          <div class="dropdown-menu">
            <router-link
              v-for="(child, ids) in nav.children"
              :key="ids"
              class="nav-link font-weight-bold f-s-14 l-h-17 main-grey"
              :to="{name: child.routeName}"
            >
              <span class="blue-hover">{{ child.label }}</span>
            </router-link>
          </div>
        </div>
      </li>
    </ul>
  </b-container>
</template>

<script>
import navbarOptions from '@/constants/navbarOptions';

export default {
  name: 'NavbarItems',
  data() {
    return {
      navbarOptions,
    };
  },
};
</script>

<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
  margin-top: 0;
  padding: 10px;
  min-width: 220px;
}
</style>
